<template>
<div>
    <section class="section-fixed-prognav">
        <div class="flow-nav-wrap">
            <div class="checkout-flow-nav-div">
                <div class="div-block-2252">
                    <div class="text-block-1727">Call us</div>
                    <a :href="supportPhoneTel" class="link-90">+1 {{ supportPhone }}</a>
                </div>
                <a href="#" class="link-block-33 w-inline-block"><img sizes="(max-width: 1000px) 100vw, 1000px" srcset="@/assets/images/NewSelf_Logo-p-500.webp 500w, @/assets/images/NewSelf_Logo-p-800.webp 800w, @/assets/images/NewSelf_Logo.webp 1000w" alt="" src="@/assets/images/NewSelf_Logo.webp" loading="lazy" class="image-378 logo-nav"></a>
                <div class="div-block-2253" v-if="active_el > 1">
                    <a  href="#" @click.prevent="GoBack()" class="nav-back-link w-inline-block">
                        <div class="text-block-507">&lt;-</div>
                    </a>
                </div>
                <div class="mobile-nav-links"  v-if="active_el > 1">
                    <a href="#" @click.prevent="GoBack()" class="nav-back-link w-inline-block">
                        <div class="text-block-507">&lt;-</div>
                    </a>
                    <a :href="supportPhoneTel" class="link-block-109 w-inline-block"><img src="@/assets/images/icon_call_1.svg" loading="lazy" alt="" class="image-692"></a>
                </div>
            </div>
        </div>
        <div class="checkout-flow-prog-div">
            <div class="quiz-progress-div">
                <div class="progress" :style="{ width: progressWidth }"></div>
            </div>
        </div>
    </section>

    <div>
        <div class="enroll-div-wrap">
            <!-- Step 1: Intro -->
            <div class="enroll-slide-2" v-if="active_el === 1">
                <div class="question-container questions-div-phone-new">
                    <div class="w-form">
                        <form @submit.prevent="handleSubmit" id="email-form-2" name="email-form-2" data-name="Email Form 2" method="get">
                            <div class="form-hero-div" style="padding-top: 0%;">
                                <img sizes="100vw" srcset="@/assets/images/stepsimage_teledoc_nS-p-500.webp 500w, @/assets/images/stepsimage_teledoc_nS.webp 641w" alt="" src="@/assets/images/stepsimage_teledoc_nS.webp" loading="lazy" class="enroll-top-image">
                                <div class="enroll-header">Lose More. Pay Less.</div>
                                <p class="formhero-sub">Fill out a few questions to make sure we can support you in your weight loss journey. <strong>Please answer accurately.</strong></p>

                                <div class="form-3-things-div">
                                    <div class="form-box-div">
                                        <div class="div-block-960 new">
                                            <div class="div-block-976 addons">
                                                <div class="div-block-974">
                                                    <div class="form-product-div">
                                                        <img src="@/assets/images/checkout_quiz.webp" loading="lazy" sizes="(max-width: 1080px) 100vw, 1080px" srcset="@/assets/images/checkout_quiz-p-500.webp 500w, @/assets/images/checkout_quiz-p-800.webp 800w, @/assets/images/checkout_quiz.webp 1080w" alt="" class="icon-img-copy _2">
                                                    </div>
                                                </div>
                                                <div>
                                                    <div class="product-name-2-copy">Pre-Qualify in Minutes<br></div>
                                                    <div class="text-block-850">Answer a few simple questions.</div>
                                                </div>
                                            </div>
                                            <div class="text-block-141 new">$348</div>
                                            <div class="div-block-1778">
                                                <img src="@/assets/images/icon_check_green.svg" loading="lazy" alt="" class="image-602">
                                            </div>
                                        </div>
                                        <a href="#" class="link-block-66 w-inline-block"></a>
                                    </div>
                                    <div class="form-box-div">
                                        <div class="div-block-960 new">
                                            <div class="div-block-976 addons">
                                                <div class="div-block-974">
                                                    <div class="form-product-div">
                                                        <img src="@/assets/images/checkout_checkup.webp" loading="lazy" sizes="(max-width: 1080px) 100vw, 1080px" srcset="@/assets/images/checkout_checkup-p-500.webp 500w, @/assets/images/checkout_checkup-p-800.webp 800w, @/assets/images/checkout_checkup.webp 1080w" alt="" class="icon-img-copy _2">
                                                    </div>
                                                </div>
                                                <div>
                                                    <div class="product-name-2-copy">Online Doctor Review<br></div>
                                                    <div class="text-block-850">Board Certified Doctors are ready.</div>
                                                </div>
                                            </div>
                                            <div class="text-block-141 new">$348</div>
                                            <div class="div-block-1778">
                                                <img src="@/assets/images/icon_check_green.svg" loading="lazy" alt="" class="image-602">
                                            </div>
                                        </div>
                                        <a href="#" class="link-block-66 w-inline-block"></a>
                                    </div>
                                    <div class="form-box-div">
                                        <div class="div-block-960 new">
                                            <div class="div-block-976 addons">
                                                <div class="div-block-974">
                                                    <div class="form-product-div ship">
                                                        <img src="@/assets/images/HIW_Deliver.webp" loading="lazy" sizes="(max-width: 1080px) 100vw, 1080px" srcset="@/assets/images/HIW_Deliver-p-500.webp 500w, @/assets/images/HIW_Deliver-p-800.webp 800w, @/assets/images/HIW_Deliver.webp 1080w" alt="" class="icon-img-copy ship">
                                                    </div>
                                                </div>
                                                <div>
                                                    <div class="product-name-2-copy">Free Next Day Shipping</div>
                                                    <div class="text-block-850">Cold Packed and at your door.</div>
                                                </div>
                                            </div>
                                            <div class="text-block-141 new">$348</div>
                                            <div class="div-block-1778">
                                                <img src="@/assets/images/icon_check_green.svg" loading="lazy" alt="" class="image-602">
                                            </div>
                                        </div>
                                        <a href="#" class="link-block-66 w-inline-block"></a>
                                    </div>
                                </div>
                                <div class="form-disclaimer-div" style="margin-bottom: 0px;">
                                    <label class="w-checkbox enroll-checkbox-field" :class="{ 'field-error': fieldErrors.agreed_to_terms }">
                                        <input type="checkbox" v-model="agreedToTerms" @change="fieldErrors.agreed_to_terms && agreedToTerms ? $delete(fieldErrors, 'agreed_to_terms') : null" name="checkbox-tos" id="checkbox-tos" data-name="Checkbox TOS" class="w-checkbox-input enroll-checkbox top">
                                        <span class="enroll-checkbox-label w-form-label" for="checkbox-tos">
                                            I Agree to NewSelf's
                                            <a href="https://newself.com/terms-of-use" target="_blank" class="enroll-checkbox-link">Terms</a>,
                                            <a href="https://newself.com/privacy-policy" target="_blank" class="enroll-checkbox-link">Privacy Policy</a>
                                            and consent to
                                            <a href="https://newself.com/telehealth-consent" target="_blank" class="enroll-checkbox-link">Telehealth</a>
                                        </span>
                                    </label>
                                </div>
                                <div v-if="fieldErrors.agreed_to_terms" class="terms-error-message">
                                    Please agree to the Terms, Privacy Policy and Telehealth consent to continue.
                                </div>
                                <div class="enroll-form-button-div">
                                    <input type="submit" data-wait="Please wait..." class="enroll-form-submit-button top w-button" value="Start my FREE visit ->">
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>

            <!-- Step 2: GLP-1 Medication Question -->
            <div class="enroll-slide-2" v-if="active_el === 2">
                <div class="question-div-2">
                    <div class="text-block-513">Are you currently taking GLP-1 medication?</div>
                    <div class="form-subs">Select the option that best describes your current situation.</div>
                    <div class="felix-form-block w-form">
                        <form @submit.prevent>
                            <a href="#" @click.prevent="selectMedication('none')" class="link-block-copy w-inline-block" :class="{ 'selected': selectedMedication === 'none' }" style="background-color: #c9e8ff;">
                                <div>
                                    <div class="text-block-545"><strong>NO, I am not currently taking GLP Medication</strong></div>
                                </div>
                            </a>
                            <a href="#" @click.prevent="selectMedication('Semaglutide')" class="link-block-copy w-inline-block" :class="{ 'selected': selectedMedication === 'Semaglutide' }">
                                <div>
                                    <div class="text-block-545">Semaglutide</div>
                                </div>
                            </a>
                            <a href="#" @click.prevent="selectMedication('Tirzepatide')" class="link-block-copy w-inline-block" :class="{ 'selected': selectedMedication === 'Tirzepatide' }">
                                <div>
                                    <div class="text-block-545">Tirzepatide</div>
                                </div>
                            </a>
                            <a href="#" @click.prevent="selectMedication('Mounjaro')" class="link-block-copy w-inline-block" :class="{ 'selected': selectedMedication === 'Mounjaro' }">
                                <div>
                                    <div class="text-block-545">Mounjaro</div>
                                </div>
                            </a>
                            <a href="#" @click.prevent="selectMedication('Ozempic')" class="link-block-copy w-inline-block" :class="{ 'selected': selectedMedication === 'Ozempic' }">
                                <div>
                                    <div class="text-block-545">Ozempic</div>
                                </div>
                            </a>
                            <a href="#" @click.prevent="selectMedication('Wegovy')" class="link-block-copy w-inline-block" :class="{ 'selected': selectedMedication === 'Wegovy' }">
                                <div>
                                    <div class="text-block-545">Wegovy</div>
                                </div>
                            </a>
                            <a href="#" @click.prevent="selectMedication('Zepbound')" class="link-block-copy w-inline-block" :class="{ 'selected': selectedMedication === 'Zepbound' }">
                                <div>
                                    <div class="text-block-545">Zepbound</div>
                                </div>
                            </a>
                            <a href="#" @click.prevent="selectMedication('Other')" class="link-block-copy w-inline-block" :class="{ 'selected': selectedMedication === 'Other' }">
                                <div>
                                    <div class="text-block-545">Other GLP Medication</div>
                                </div>
                            </a>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
export default {
    name: 'WeightLossPreForm',
    data() {
        return {
            active_el: 1,
            totalSteps: 2,
            agreedToTerms: true,
            selectedMedication: '',
            fieldErrors: {},
        }
    },
    computed: {
        progressWidth() {
            return `${(this.active_el / this.totalSteps) * 100}%`;
        }
    },
    methods: {
        GoBack() {
            if (this.active_el > 1) {
                this.active_el--;
            }
        },
        handleSubmit() {
            if (!this.agreedToTerms) {
                this.$set(this.fieldErrors, 'agreed_to_terms', true);
                return;
            }
            this.$delete(this.fieldErrors, 'agreed_to_terms');
            this.active_el++;
        },
        selectMedication(medication) {
            this.selectedMedication = medication;
            if (medication === 'none') {
                this.$router.push('/glp-signup');
            } else {
                try {
                    localStorage.setItem('preform_glp_data', JSON.stringify({
                        currentlyTakingGLP: 'Yes',
                        currentGLPMed: medication
                    }));
                } catch (e) {
                    // ignore — quota or disabled storage
                }
                this.$router.push({ path: '/', query: { step: 2, medication } });
            }
        }
    },
    watch: {
        active_el() {
            window.scrollTo(0, 0);
        }
    }
}
</script>

<style scoped>
.section-fixed-prognav {
    position: static !important;
}

.questions-div-phone-new {
    max-width: 580px;
    display: flex;
    justify-content: center;
}

.nav-back-link {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 4px 10px;
    margin-right: 6px;
    text-decoration: none;
    cursor: pointer;
}

.nav-back-link .text-block-507 {
    font-size: 22px;
    line-height: 1;
    color: #08466f;
}

/* Center question text */
.question-div-2 .text-block-513,
.question-div-2 .form-subs {
    text-align: center !important;
}

@media screen and (max-width: 479px) {
    .enroll-header {
        text-align: left;
        width: 100%;
        font-size: 32px;
        line-height: 8px;
        margin-top: 35px;
    }
    .product-name-2-copy {
        margin-bottom: 3px;
        font-size: 18px;
        font-weight: 900;
        line-height: 21px;
    }
    .enroll-checkbox-label {
        font-size: 9px;
    }
    .formhero-sub {
        text-align: left;
        width: 100%;
        margin-bottom: 30px;
        font-size: 16px;
        line-height: 20px;
        padding-top: 15px;
    }

    .enroll-slide-2 {
        flex-direction: column;
        align-items: left;
        padding-bottom: 60px;
        display: flex;
        margin-top: 12px;
    }
}

@media screen and (max-width: 380px) {
    .enroll-header {
        flex-direction: column;
        align-items: left;
        padding-bottom: 5px;
        display: flex;
        margin-top: 7px;
    }
    .form-3-things-div {
        flex-flow: column;
        align-items: flex-start;
        width: 100%;
        margin-bottom: 5px;
    }
}

@media screen and (max-width: 350px) {
    .enroll-header {
        font-size: 30px;
    }
}

.field-error {
    border-color: #ff4444 !important;
    border-width: 2px !important;
}

.field-error .w-checkbox-input {
    outline: 2px solid #ff4444;
    outline-offset: 2px;
}

.terms-error-message {
    color: #ff4444;
    font-size: 13px;
    margin-top: 8px;
    text-align: center;
}

/* Constrain entire form section */
.question-div-2 {
    width: 100%;
    max-width: 550px;
    margin: 0 auto;
}

.felix-form-block {
    max-width: 550px;
    margin-left: auto;
    margin-right: auto;
}

.link-block-copy.selected {
    border-color: #08466f;
    background-color: #f0f7fc;
}
</style>
